import {Button, Modal} from "antd";
import "./new-segment-modal.css";
import {useEffect, useState} from "react";
import StepsProcess from "../../../components/stepsProcess/StepsProcess";
import {MessageOutlined} from "@ant-design/icons";
import SegmentConditionBuilder from "../newSegment/SegmentConditionBuilder";
import SegmentDetailsStep from "../newSegment/SegmentDetailsStep";
import {ConditionsProps, defaultConditions} from "../../../utils/segmentBuilder";
import {createSegment} from "../../../api/createSegment";
import useUserContext from "../../../hooks/useUserContext";
import Celebration from "../../../assets/illustrations/celebration.png";
import useAppContext from "../../../hooks/useAppContext";

interface NewSegmentModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const NewSegmentModal = ({ isOpen, onClose }: NewSegmentModalProps) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const { selectedDomain } = useUserContext();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { actions: { loadSegments }} = useAppContext();

    useEffect(() => {
        if(!isOpen) {
            setTitle('');
            setDescription('');
        }
    }, [isOpen]);

    const onSubmitNewSegment = async (segmentState: ConditionsProps[]) => {
        if(!selectedDomain) return false;
        setIsSubmitting(true);
        const response = await createSegment({ domain: selectedDomain, title, description, conditions: segmentState });
        setIsSubmitting(false);
        const isOk = response.status === 200 && response.data === 'success';
        isOk && loadSegments();
        return isOk;
    }

    const closeModal = () => {
        !isSubmitting && onClose();
    }

    const steps = [
        {
            title: 'New Segment',
            icon: <MessageOutlined />,
        },
        {
            title: 'Conditions',
            icon: <MessageOutlined />,
        },
    ];

    return (
        <Modal open={isOpen} onCancel={closeModal} destroyOnHidden={true} className="segment-modal" width={950}
               // height={window.innerHeight * 0.85}
               // modalRender={(modalNode) => modalNode}
               okButtonProps={{ style: { display: 'none' }}} cancelButtonProps={{ style: { display: 'none' }}}>
            <div className="modal-header">
                <div className="title">Create New Audience</div>
                <div className="description">Define a new audience by selecting user behaviors and traits to target in your next campaign.</div>
            </div>
            <StepsProcess initialStep={1} steps={steps} hideStepsTracker={true} className="segment-steps">
                <SegmentDetailsStep isSubmitting={isSubmitting} onClose={closeModal} title={title} setTitle={setTitle} description={description} setDescription={setDescription} />
                <SegmentConditionBuilder isNew={true} initialSegmentState={[defaultConditions]} isSubmitting={isSubmitting} isOpen={isOpen} onSubmit={onSubmitNewSegment} />
                <div className="success-segment-creation-celebration">
                    <div className="celebration-text">
                        Great job, you've successfully created "{title}"!
                    </div>
                    <img src={Celebration} className="celebration-image" />
                    <Button onClick={closeModal} type="primary" size="large">Close</Button>
                </div>
            </StepsProcess>
        </Modal>
    )
}

export default NewSegmentModal;